export { dxTrOverrides } from './dx-tr-overrides';
